import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import {Signals} from "@/Imports";
import ScaleManager from "../stage/ScaleManager";
import Utils from "@base/utils/Utils";
import gsap from "gsap";

export default class SnowContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init()
  }

  init(data) {
    Signals.forceRoundStart.add(this.reset, this)
    Signals.roundStart.add(this.start, this)
    Signals.roundEnd.add(this.onRoundEnd, this)

    Signals.startFeature.add(this.onStartFeature, this)
    Signals.stopFeature.add(this.onStopFeature, this)

    // Debug rectangle
    // this.blank = new PIXI.Graphics()
    // this.blank.beginFill(0xff0000, 0.2)
    // this.blank.drawRect(50,50, 800, 500)
    // this.blank.endFill()
    // this.addChild(this.blank)

    this.MAX_SNOWFLAKES = 600

    this.quite = 0.3
    this.fast = 1.1
    this.extra = 8

    this.mode = this.quite
    this.multX = 1
    this.multY = 1.1
    this.snowContainer = new PIXI.Container()
    this.addChild(this.snowContainer)
    this.snow = new Array(this.MAX_SNOWFLAKES)
      .fill(1)
      .map(v => this.createSnowflake())

    this.start()
  }

  createSnowflake = () => {
    const {x, y} = this.newPosition()
    const g = new PIXI.Graphics()

    g.size = Math.random() * 2
    if (Math.random() > 0.90)
      g.size = 2.4
    if (Math.random() > 0.98)
      g.size = 5

    g.beginFill(0xffffff)
    g.drawCircle(0, 0, g.size)
    g.endFill()
    g.x = x
    g.y = y
    this.snowContainer.addChild(g)
    return g
  }

  newPosition = () => {
    const {width, height} = ScaleManager.currentSizes.total
    const x = Utils.getRandomInt(0, width*2.3)
    const y = Utils.getRandomInt(-100, 0)
    return {x, y}
  }

  reset() {
    this._reset()
  }

  start() {
    this.reset()
    Signals.tick.remove(this.update, this)
    Signals.tick.add(this.update, this)

    gsap.to(this, 2, {mode: this.fast})
  }

  onRoundEnd() {
    this._reset()
  }

  onStartFeature() {
    gsap.to(this, 2, {mode: this.extra})
    gsap.to(this.snowContainer, 2, {alpha: 1})
  }

  onStopFeature() {
    gsap.to(this, 2, {mode: this.fast})
    gsap.to(this.snowContainer, 2, {alpha: 0.3})
  }

  _reset() {
    gsap.to(this, 2, {mode: this.quite})
    gsap.to(this.snowContainer, 2, {alpha: 0.3})
  }

  update() {
    const {height} = ScaleManager.currentSizes.total
    this.snow.forEach(s => {
      s.x -= this.multX * (s.size / 2) * this.mode

      if (this.mode === this.extra)
        s.y += this.multY * (s.size / 2) + 2
      else
        s.y += this.multY * (s.size / 2)

      s.alpha = 1-Math.max(0.2, Math.min(1, (s.y / height)))

      if (s.y > height || s.x < 0) {
        const {x, y} = this.newPosition()
        s.x = x
        s.y = y
      }
    })
  }

}
